import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import { BrowserRouter } from 'react-router-dom';
import i18n from "./i18n";

// Suppress ResizeObserver errors globally
const resizeObserverErrorHandler = (event) => {
  const errorMessage = "ResizeObserver loop completed with undelivered notifications.";
  if (event.message === errorMessage || event.message.includes("ResizeObserver")) {
    // Suppress the error
    event.preventDefault();
    console.warn("Suppressed ResizeObserver Error:", event.message);
    return;
  }
  console.error(event); // Log other errors normally
};
window.addEventListener("error", resizeObserverErrorHandler);

const root = ReactDOM.createRoot(document.getElementById('root'));
const appRootEl = document.getElementById('root');
if (appRootEl) {
  appRootEl.setAttribute("dir", i18n.dir(i18n.resolvedLanguage || i18n.language || "ar"));
}
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
